import { render, staticRenderFns } from "./DeductionsPlanForm.vue?vue&type=template&id=21834b8e&scoped=true&"
import script from "./DeductionsPlanForm.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21834b8e",
  null
  
)

export default component.exports